import { ObservableArray, View } from "binder"
import { ServerSideDataLoader } from "uicomponents";
import { SearchCustomerViewModel } from "../searchCustomer/searchCustomer-viewModel";
import { InterfacePerson, InterfacePersonsListViewModel } from "./interfacePersonsList-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class InterfacePersonsListView extends View<InterfacePersonsListViewModel>{
    GetViewUniqueId(): string {
        return "V-3D6AFA8C-1F7B-436D-9093-64710BEDC50F"
    }
    loadHtml(): string {
        let element = require('./interfacePersonsList.html').default;
        let style = require('./interfacePersonsList.less');
        return element;
    }
    constructor() {
       super();
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set interfacePersons(v: ObservableArray<InterfacePerson>) { this._interfacePersons = v; } public get interfacePersons(): ObservableArray<InterfacePerson> { return this._interfacePersons;} private _interfacePersons: ObservableArray<InterfacePerson>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set customerSelected(v: boolean) { this._customerSelected = v; } public get customerSelected(): boolean { return this._customerSelected;} private _customerSelected: boolean;
    public set customerSelector(v: SearchCustomerViewModel) { this._customerSelector = v; } public get customerSelector(): SearchCustomerViewModel { return this._customerSelector;} private _customerSelector: SearchCustomerViewModel;
    public set selectedCustomerName(v: string) { this._selectedCustomerName = v; } public get selectedCustomerName(): string { return this._selectedCustomerName;} private _selectedCustomerName: string;
    public set selectedCustomerId(v: string) { this._selectedCustomerId = v; } public get selectedCustomerId(): string { return this._selectedCustomerId;} private _selectedCustomerId: string;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  
    
    addNewInterfacePerson() {
        this.dataContext.showAddNewInterfacePersonForm();
    }
}
